export default __webpack_public_path__ + "static/media/letMeTakeYouAway.09f7235c.png";